import { Background, CardStyle, DEFAULT_AVATARS, DEFAULT_BACKGOUNDS, DEFAULT_CARD_STYLES, DEFAULT_FELTS, Felt, IAvatar } from '@soposopo/sopo-models';
export { Background, Felt, Item, IAvatar, CardStyle, DEFAULT_AVATARS, DEFAULT_BACKGOUNDS, DEFAULT_CARD_STYLES, DEFAULT_FELTS } from '@soposopo/sopo-models';

export interface BetSizes {
    bet1: string;
    bet2: string;
    bet3: string;
}

export const INITIAL_BET_SIZES: BetSizes = {
    bet1: '1/4',
    bet2: '1/2',
    bet3: '3/4'
}

export interface RaiseSizes {
    raise1: string;
    raise2: string;
    raise3: string;
}

export interface Transaction {
    tokenId: string;
    contractAddress: string;
}

export const INITIAL_RAISE_SIZES: RaiseSizes = {
    raise1: '2',
    raise2: '3',
    raise3: '4'
}

export interface PresetSizes {
    preset1: number;
    preset2: number;
    preset3: number;
}

export interface GameTypePresets {
    preFlop: PresetSizes;
    postFlop: PresetSizes;
}

export interface BetPresets {
    noLimit: GameTypePresets;
    plo: GameTypePresets;
}

export const INITIAL_BET_PRESETS: BetPresets = {
    noLimit: {
        preFlop: { preset1: 3, preset2: 3.5, preset3: 4 },
        postFlop: { preset1: 50, preset2: 75, preset3: 100 },
    },
    plo: {
        preFlop: { preset1: 2, preset2: 2.5, preset3: 3 },
        postFlop: { preset1: 30, preset2: 50, preset3: 66 },
    },
};

export interface ThemeOptions {
    showAvatars: boolean;
    showStack: boolean;
    autoTimeBank: boolean;
    textMessage: boolean;
    showEmoji: boolean;
    avatarsInCircle: boolean;
    muteSounds: boolean;
}

export const INITIAL_THEME_OPTIONS: ThemeOptions = {
    showAvatars: true,
    showStack: false,
    autoTimeBank: false,
    textMessage: true,
    showEmoji: true,
    avatarsInCircle: true,
    muteSounds: false,
}

export interface GameThemeSettings extends ThemeOptions  {
    felt: Felt;
    background: Background;
    cardStyle: CardStyle;
    betSizes: BetSizes;
    raiseSizes: RaiseSizes;
    betPresets: BetPresets;
    nftPositions: number;
    transactions: Transaction[];
    unlockedAvatars: IAvatar[];
}

export interface GameThemeSettingsState extends GameThemeSettings {
    unlockedFelts: Felt[];
    unlockedBackgrounds: Background[];
    unlockedCardStyles: CardStyle[];
}

const allowedAvatarsForFree: IAvatar[] = [ 
    { id: 148, url: 'assets/img/avatars/148.png' },
    { id: 149, url: 'assets/img/avatars/149.png' },
    { id: 150, url: 'assets/img/avatars/150.png' },
    { id: 151, url: 'assets/img/avatars/151.png' },
    { id: 173, url: 'assets/img/avatars/173.png' },
    { id: 155, url: 'assets/img/avatars/155.png' },
    { id: 156, url: 'assets/img/avatars/156.png' },
    { id: 159, url: 'assets/img/avatars/159.png' },
    { id: 160, url: 'assets/img/avatars/160.png' },
];

export const DEFAULT_AND_FREE_AVATARS = [
    ...DEFAULT_AVATARS,
    ...allowedAvatarsForFree
]

export const GAME_THEME_SETTINGS_INIT_STATE: GameThemeSettingsState = {
    felt: { ...DEFAULT_FELTS[0] },
    background: { ...DEFAULT_BACKGOUNDS[0] },
    cardStyle: { ...DEFAULT_CARD_STYLES[0] },
    betSizes: INITIAL_BET_SIZES,
    raiseSizes: INITIAL_RAISE_SIZES,
    betPresets: INITIAL_BET_PRESETS,
    nftPositions: 0,
    transactions: [],
    unlockedFelts: [...DEFAULT_FELTS],
    unlockedBackgrounds: [...DEFAULT_BACKGOUNDS],
    unlockedCardStyles: [...DEFAULT_CARD_STYLES],
    unlockedAvatars: [...DEFAULT_AND_FREE_AVATARS],
    ...INITIAL_THEME_OPTIONS,
}
